// How an authorized pickup is named on the «Entrega» detail. THREE forms, not two, because the
// wire carries two different absences and the agent owes a different sentence to each: `id: null`
// says the parcel was authorized to a phone with no account behind it, whereas an `id` with no
// name says there IS an account and its row could not be read — a dangling id, or a «Usuario»
// taken down. Collapsing them would tell the agent «we cannot show this person» about somebody
// who was never a person in the first place.
//
// A name that arrives wins over both, id or no id: if the backend can name them, that is the
// answer, and second-guessing it from the id would be the panel overriding the source.
// TODO: i18n — copy en ES hasta Fase 1.
const UNREADABLE_ACCOUNT = '—';
const NO_ACCOUNT = 'Recogida autorizada';

export function authorizedDisplayName(person: { id: number | null; name: string | null }): string {
  const named = person.name?.trim();
  if (named !== undefined && named !== '') return named;
  return person.id === null ? NO_ACCOUNT : UNREADABLE_ACCOUNT;
}
